// package imports
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Tab, Tabs } from "react-bootstrap";
// project imports
import './qms-dashbored-page-tab-component.css'
import qmsDashboardPageStore from "modules/qms-flow/qms-dashboard-page/qms-dashboard-page-store";
import pasaCampaignStore from "../pasa-campaign/pasa-campaign-store";
import { toJS } from "mobx";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import QMSTabConstant from "constants/QMSTabConstant";
import * as APITypes from "../../../../constants/API";
import axios from "axios";
import bonusCampaignStore from "modules/qms-flow/bonus-campaign/bonus-campaign-store";
import gapCampaignStore from "modules/qms-flow/gap-campaign/gap-campaign-store";


function QmsDashboredPageTabComponent(props) {
    const [key, setKey] = useState("");
    const [tabsList, setTabsList] = useState([])
    const history = useHistory()
    const location = window.location.pathname;

    useEffect(() => {
        const fetchData = async () => {
            let response = await axios.get(`${APITypes.ACTIVE_CAMPAIGN_TABS_LIST}`);
            setTabsList(response?.data);
            let filterData = response?.data.filter((item) => item.path === location)[0];
            setKey(filterData.name);
        };
        fetchData();
    }, []);

    useEffect(() => {
        let path = location
        if (tabsList.length > 0) {
            let filterData = tabsList.filter((item) => item.path === path)[0]
            setKey(filterData.name)
        }

    }, [location])

    const showCount = (tab_name) => {
        let count = 0
        switch (tab_name) {
            case QMSTabConstant.QUOTES_AND_APPLICATIONS:
                let quotesNApplicationTotalCount = 0;
                let qmsListData = qmsDashboardPageStore.qmsListData ? toJS(qmsDashboardPageStore.qmsListData) : [];
                if (qmsListData && qmsListData?.all_journey_lists?.length > 0) {
                    qmsListData?.all_journey_lists.forEach((journeyObj, index) => {
                        quotesNApplicationTotalCount = quotesNApplicationTotalCount + journeyObj.journey_list.length;
                    });
                }
                count = quotesNApplicationTotalCount
                break;
            case QMSTabConstant.PASA_CAMPAIGN:
                count = pasaCampaignStore.campaignListCount
                break
            case QMSTabConstant.BONUS_CAMPAIGN:
                count = bonusCampaignStore.campaignListCount
                break
            case QMSTabConstant.OPPORTUNITY_CAMPAIGN:
                count = gapCampaignStore.campaignListCount
                break
            default:
                break;
        }
        return count;
    }

    return (
        <div className="qmsDashbored-page-tab-component">
            <Tabs
                className={"flex-nowrap qms-das"}
                activeKey={key}
                onSelect={(k) => {
                    setKey(k)
                    let filterData = tabsList.filter((item) => item.name === k)[0]
                    history.push({ pathname: filterData?.path })
                }}
            >
                {tabsList.map((item, index) =>
                    <Tab key={index} eventKey={item.name} title={`${item.title}  ${ item.name == key ? `[${showCount(item?.name)}]` : ""} `}></Tab>
                )}
            </Tabs>
        </div>
    )
}
export default observer(QmsDashboredPageTabComponent);